import { Model, ModelClass } from './Model';

export const SkuGender: ModelClass = Model('SkuGender', {
    endpoint: 'apparel-sku-genders',
})`
    id:Int;
    name:String;
`;
